module.exports = __webpack_public_path__ + "img/teamCivilian.9448d811.jpg";